import {
  type ImageToolProps,
  type VideoToolProps,
  type ToolProps,
} from '../types';

import { BoldTool } from './bold-tool';
import { BulletListTool } from './bullet-list-tool';
import { EmphasisTool } from './emphasis-tool';
import { HeadingH1Tool } from './heading-h1-tool';
import { HeadingH2Tool } from './heading-h2-tool';
import { HeadingH3Tool } from './heading-h3-tool';
import { ImageTool } from './image-tool';
import { ItalicTool } from './italic-tool';
import { LinkTool } from './link-tool';
import { NumberedListTool } from './numbered-list-tool';
import { VideoTool } from './video-tool';
import { XingQuoteTool } from './xing-quote-tool';

const HEADING_NODES = ['heading'];
const LIST_NODES = ['orderedList', 'bulletList'];
const XING_QUOTE_NODES = ['quote', 'quoteCaption'];
const XING_IMAGE_NODES = ['xingImage', 'imageCaption'];
const XING_VIDEO_NODES = ['xingVideo', 'videoCaption'];

type Tool = {
  enabled: boolean;
  component:
    | React.FC<ToolProps>
    | React.FC<ImageToolProps>
    | React.FC<VideoToolProps>;
  notAllowedNodes: Array<string>;
};

type ToolsTypes =
  | 'BoldTool'
  | 'ItalicTool'
  | 'HeadingH1Tool'
  | 'HeadingH2Tool'
  | 'HeadingH3Tool'
  | 'BulletListTool'
  | 'NumberedListTool'
  | 'LinkTool'
  | 'ImageTool'
  | 'VideoTool'
  | 'XingQuoteTool'
  | 'EmphasisTool';

export const TOOLS: Record<ToolsTypes, Tool> = {
  BoldTool: {
    enabled: true,
    component: BoldTool,
    notAllowedNodes: [
      ...HEADING_NODES,
      ...XING_QUOTE_NODES,
      ...XING_IMAGE_NODES,
      ...XING_VIDEO_NODES,
    ],
  },
  ItalicTool: {
    enabled: true,
    component: ItalicTool,
    notAllowedNodes: [
      ...HEADING_NODES,
      ...XING_QUOTE_NODES,
      ...XING_IMAGE_NODES,
      ...XING_VIDEO_NODES,
    ],
  },
  HeadingH1Tool: {
    enabled: true,
    component: HeadingH1Tool,
    notAllowedNodes: [],
  },
  HeadingH2Tool: {
    enabled: true,
    component: HeadingH2Tool,
    notAllowedNodes: [],
  },
  HeadingH3Tool: {
    enabled: true,
    component: HeadingH3Tool,
    notAllowedNodes: [],
  },
  BulletListTool: {
    enabled: true,
    component: BulletListTool,
    notAllowedNodes: [],
  },
  NumberedListTool: {
    enabled: true,
    component: NumberedListTool,
    notAllowedNodes: [],
  },
  LinkTool: {
    enabled: true,
    component: LinkTool,
    notAllowedNodes: [
      ...HEADING_NODES,
      ...LIST_NODES,
      ...XING_QUOTE_NODES,
      ...XING_IMAGE_NODES,
      ...XING_VIDEO_NODES,
    ],
  },
  ImageTool: {
    enabled: true,
    component: ImageTool,
    notAllowedNodes: [
      ...HEADING_NODES,
      ...LIST_NODES,
      ...XING_QUOTE_NODES,
      ...XING_IMAGE_NODES,
      ...XING_VIDEO_NODES,
    ],
  },
  VideoTool: {
    enabled: true,
    component: VideoTool,
    notAllowedNodes: [
      ...HEADING_NODES,
      ...LIST_NODES,
      ...XING_QUOTE_NODES,
      ...XING_IMAGE_NODES,
      ...XING_VIDEO_NODES,
    ],
  },
  XingQuoteTool: {
    enabled: true,
    component: XingQuoteTool,
    notAllowedNodes: [
      ...HEADING_NODES,
      ...LIST_NODES,
      ...XING_IMAGE_NODES,
      ...XING_VIDEO_NODES,
    ],
  },
  EmphasisTool: {
    enabled: true,
    component: EmphasisTool,
    notAllowedNodes: [
      ...HEADING_NODES,
      ...LIST_NODES,
      ...XING_QUOTE_NODES,
      ...XING_VIDEO_NODES,
    ],
  },
};
